define([
    'edge/quoteandbind/common/models/Submission',
], (Submission)=> {
    return ['$q',
        'JsonRPCService',
        'qnb.ErrorHandlingService',
        'qnb.endpointConfig',
        ($q, JsonRPCService, ErrorHandlingService, endpointConfig)=> {


            /**
             *
             * @param {Object} params
             * @param params.callGroups
             * @param params.submissionDTO
             * @param {String} params.processName
             * @param {Boolean} params.handleErrorBeforeRequest
             * @param {Boolean} params.setDTOBeforeHandling
             * @returns Promise
             */
            function processSubmission(params) {
                let submissionDTO = params.submissionDTO;
                const handleErrorBeforeRequest = params.handleErrorBeforeRequest;
                const setDTOBeforeHandling = params.setDTOBeforeHandling;

                const deferred = $q.defer();
                if (handleErrorBeforeRequest) {
                    ErrorHandlingService.checkSessionUUID(submissionDTO, deferred);
                }


                const endpoint = endpointConfig.loadSaveEndpoint;
                JsonRPCService.send('quote', endpoint, params.processName, [submissionDTO], params.callGroups).then(
                    (response)=> {
                        if (!handleErrorBeforeRequest) {
                            if (setDTOBeforeHandling) {
                                submissionDTO = new Submission(response);
                            }
                            ErrorHandlingService.checkSessionUUID(submissionDTO, deferred);
                            if (!setDTOBeforeHandling) {
                                submissionDTO = new Submission(response);
                            }
                        } else {
                            submissionDTO = new Submission(response);
                        }
                        return deferred.resolve(submissionDTO);
                    }, (error, status, headers)=> {
                        return deferred.reject([error, status, headers]);
                    });
                return deferred.promise;
            }

            return {
                createSubmission: (callGroups, submissionDTO)=> {
                    return processSubmission({
                        callGroups,
                        submissionDTO,
                        processName: 'create',
                        handleErrorBeforeRequest: false,
                        setDTOBeforeHandling: true,
                    });
                },
                saveAndQuoteSubmission: (callGroups, submissionDTO)=> {
                    return processSubmission({
                        callGroups,
                        submissionDTO,
                        processName: 'saveAndQuote',
                        handleErrorBeforeRequest: false,
                        setDTOBeforeHandling: false,
                    });
                },
                saveSubmission: (callGroups, submissionDTO)=> {
                    return processSubmission({
                        callGroups,
                        submissionDTO,
                        processName: 'save',
                        handleErrorBeforeRequest: false,
                        setDTOBeforeHandling: false,
                    });
                },
                quoteSubmission: (callGroups, quoteID, sessionUUID)=> {
                    let submissionDTO;
                    const deferred = $q.defer();
                    const endpoint = endpointConfig.loadSaveEndpoint;
                    JsonRPCService.send('quote', endpoint, 'quote', [quoteID, sessionUUID], callGroups).then(
                        (response)=> {
                            ErrorHandlingService.checkSessionUUID({sessionUUID}, deferred);
                            submissionDTO = new Submission(response);
                            return deferred.resolve(submissionDTO);
                        }, (error, status, headers)=> {
                            return deferred.reject([error, status, headers]);
                        });
                    return deferred.promise;
                },
                saveQuotedSubmission: (callGroups, submissionDTO)=> {
                    return processSubmission({
                        callGroups,
                        submissionDTO,
                        processName: 'updateQuotedSubmission',
                        handleErrorBeforeRequest: true,
                        setDTOBeforeHandling: false,
                    });
                },
                bindSubmission: (callGroups, submissionDTO)=> {
                    return processSubmission({
                        callGroups,
                        submissionDTO,
                        processName: 'bind',
                        handleErrorBeforeRequest: false,
                        setDTOBeforeHandling: false,
                    });
                },
                retrieveSubmission: (callGroups, submissionDTO)=> {
                    return processSubmission({
                        callGroups,
                        submissionDTO,
                        processName: 'retrieve',
                        handleErrorBeforeRequest: false,
                        setDTOBeforeHandling: false,
                    });
                },
                editQuotedSubmissionAndRequote: (callGroups, submissionDTO) => {
                    return processSubmission({
                        callGroups: callGroups,
                        submissionDTO: submissionDTO,
                        processName: 'editQuotedSubmissionAndRequote',
                        handleErrorBeforeRequest: false,
                        setDTOBeforeHandling: false,
                    });
                },
            };
        }];
});


// WEBPACK FOOTER //
// ../common/js/src/edge/quoteandbind/common/services/LoadSaveService.js